module.exports = __webpack_public_path__ + "img/added.c675b242.png";